<template>
  <Admin style="background: white">
    <v-main v-if="!isProductListLoading" class="wrapper">
      <v-container v-if="!selectedCompanyProductList.isExchangeRate" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
          ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <v-card class="tw-p-4 tw-m-2 tw-rounded-lg tw-min-h-70">
          <v-row class="tw-px-6 tw-pt-8 tw-justify-between">
            <div class="tw-flex tw-gap-4">
              <div class="tw-pt-2">
                <img class="tw-rounded-full tw-shadow-md" :src="companyLogo" width="38"/>
              </div>
              <h3 class="tw-pt-4 tw-text-lg tw-font-bold">Exchange Rate History</h3>
            </div>
            <v-col class="pa-0" cols="3">
              <!-- date picker for column podate  -->
              <v-menu
                v-model="isOpenTodayDatePicker"
                :close-on-content-click="true"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="292px"
                min-width="292px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="เลือก ปี-เดือน"
                    append-icon="mdi-calendar-month-outline"
                    readonly
                    :value="dateDsp"
                    outlined
                    class="ma-0 pa-0"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  locale="en-in"
                  v-model="dateSearch"
                  no-title
                  type="month"
                  :format="
                    (date) =>
                      new Date(date).toLocaleDateString('en-in', {
                        year: 'numeric',
                        month: 'long',
                      })
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="tw-px-6">
            <v-col class="pa-0" cols="12">
              <div class="table-container">
                <table class="exchange-rate-history-table">
                  <thead>
                    <tr>
                      <th><div>DATE</div></th>
                      <th><div>BANK</div></th>
                      <th><div>B1CODE</div></th>
                      <th><div>CURRENCY</div></th>
                      <th><div>EXCHANGRE RATE</div></th>
                      <th><div>RATE OF DATE</div></th>
                      <th><div>CREATED DATE</div></th>
                    </tr>
                  </thead>
                    <tbody>
                    <template v-for="(item, idx1) of rateHistory">
                      <tr :key="`${idx1}`">
                        <td
                          :rowspan="
                            item.rowNum + 1 + item.value.length
                          "
                        >
                          {{ item.date }}
                        </td>
                        <template v-if="item.value.length == 0">
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                        </template>
                      </tr>
                      <template v-for="(bRate, idx2) of item.value">
                        <tr :key="`${idx1}_${idx2}`">
                          <td :rowspan="bRate.rates.length + 1">
                            <div class="tw-pl-3 tw-flex tw-items-center tw-gap-3">
                              <img v-if="getBankLogo(bRate.bank) == '' ? false : true" :src="getBankLogo(bRate.bank)" alt="bank logo" width="24" style="border-radius: 100%;"/>
                              <span>{{ bRate.bank }}</span>
                            </div>
                          </td>
                        </tr>
                        <template v-for="(rate, idx3) of bRate.rates">
                          <template v-if="isFirstRowExist && idx1 != 0">
                            <tr v-if="idx2 === 0" :key="`${idx1}_${idx2}_${idx3}`">
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.B1Code }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.CurrencyCode }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''" style="text-align: end; padding-right: 3rem;">{{ rate.Value }}</td>
                              <td v-if="idx3 === 0" :rowspan="bRate.rates.length != 0 ? item.rowNum + (item.value.length == item.rowNum ? 1 : 0) : 1">
                                {{ rate.RateDate }}
                              </td>
                              <td v-if="idx3 === 0" :rowspan="bRate.rates.length != 0 ? item.rowNum + (item.value.length == item.rowNum ? 1 : 0) : 1">
                                {{ rate.CreateDate }}
                              </td>
                            </tr>
                            <tr v-if="idx2 > 0" :key="`${idx1}_${idx2}_${idx3}`">
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.B1Code }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.CurrencyCode }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''" style="text-align: end; padding-right: 3rem;">{{ rate.Value }}</td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr v-if="idx2 === 0" :key="`${idx1}_${idx2}_${idx3}`">
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.B1Code }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.CurrencyCode }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''" style="text-align: end; padding-right: 3rem;">{{ rate.Value }}</td>
                              <td v-if="idx3 === 0" :rowspan="bRate.rates.length != 0 ? item.rowNum + (item.value.length == item.rowNum ? 1 : 0) : 1">
                                {{ rate.RateDate }}
                              </td>
                              <td v-if="idx3 === 0" :rowspan="bRate.rates.length != 0 ? item.rowNum + (item.value.length == item.rowNum ? 1 : 0) : 1">
                                {{ rate.CreateDate }}
                              </td>
                            </tr>
                            <tr v-if="idx2 > 0" :key="`${idx1}_${idx2}_${idx3}`">
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.B1Code }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''">{{ rate.CurrencyCode }}</td>
                              <td :class="rate.isEvenRow ? 'even-row' : ''" style="text-align: end; padding-right: 3rem;">{{ rate.Value }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>
                    </template>
                  </tbody>
                </table>
                </div>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-main>
    <v-main v-else>
      <div class="tw-flex tw-justify-center tw-mt-20">
        <v-progress-circular
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import _isEqual from "lodash/isEqual";
import firebase from "firebase/app";
import { mapState } from "vuex";
const _ = require("lodash");
import { PDFDocument } from "pdf-lib";
import logActivity from "@/libs/activityLogger";

export default {
  data() {
    const today = new Date();
    const yesterday = new Date(today); 
    // if today is 1st day of month, get the last day of last month
    if (today.getDate() !== 1) {
      yesterday.setDate(today.getDate() - 1);
    } 
    const yesterdayISO = yesterday.toISOString().substr(0, 10);
    const companyID = this.$route.params.companyId;
    return {
      companyID: companyID,
      dateSearch: yesterdayISO,
      dateDsp: "",
      isOpenTodayDatePicker: false,
      rateHeader: [],
      rateHistory: [],
      isFirstRowExist: false,
    };
  },
  name: "exchangeRateHistory",
  components: {
    Admin,
  },
  methods: {
    generateDateRange(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const dateArray = [];

      let currentDate = startDate;
      while (currentDate <= endDate) {
        dateArray.push(currentDate.toISOString().split("T")[0]);
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateArray;
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month] = date.split("-");
      return `${year}-${month}`;
    },
    formatDateDMY(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    formatDateFirebase(date) {
      if (!date) return "";
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");

      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    async fetchHistoryRate() {
      this.rateHeader = [];
      this.rateHistory = [];

      let fcPath = `/Companies/${this.companyID}`;
      var dbRefEx = fc.db.collection(fcPath + "/ExchangeRate").doc("setting");
      const docEx = await dbRefEx.get();
      let docDataEx = docEx.data();
      let currencySetting = docDataEx.currency;
      // console.log('currencySetting',currencySetting)
      //create table header
      this.rateHeader.push({
        text: "Date",
        align: "start",
        sortable: false,
        value: "date",
        class:
          "width120 text-uppercase font-weight-bold text-center custom-header black--text ",
      });

      for (const key in currencySetting) {
        this.rateHeader.push(
          {
            text: "Code",
            value: key,
            class:
              "text-uppercase font-weight-bold text-center custom-header black--text",
          },
          {
            text: "Currency",
            value: "Currency" + key,
            class:
              "text-uppercase font-weight-bold text-center custom-header black--text",
          },
          {
            text: "Exchange Rate",
            value: "ExchangeRate" + key,
            class:
              "text-uppercase font-weight-bold text-center custom-header black--text",
          },
          {
            text: "Bank",
            value: "Bank",
            class:
              "width120 text-uppercase font-weight-bold text-center custom-header black--text",
          }
        );
      }

      this.rateHeader.push(
        {
          text: "Rate of Date",
          value: "RateOfDate",
          class:
            "tw-items-center text-uppercase font-weight-bold text-center custom-header black--text",
        },
        {
          text: "Create Date",
          value: "CreateDate",
          class:
            "tw-w-[200px] text-uppercase font-weight-bold text-center custom-header black--text",
        }
      );
      //create table header

      const month = this.dateDsp;
      const [year, monthNumber] = month.split("-");
      const startDate = `${month}-01`;
      const endDateObj = new Date(year, monthNumber, 0);
      const endDate = `${month}-${endDateObj
        .getDate()
        .toString()
        .padStart(2, "0")}`;

      const dateRange = this.generateDateRange(startDate, endDate);
      try {
        const exchangeRateCollectionRef = fc.db.collection(
          `${fcPath}/ExchangeRate/HistoryRate/data`
        );
        const querySnapshot = await exchangeRateCollectionRef
          .where(new firebase.firestore.FieldPath.documentId(), ">=", startDate)
          .where(new firebase.firestore.FieldPath.documentId(), "<=", endDate)
          .get();

        const docMap = {};
        // console.log('querySnapshot',querySnapshot)
        querySnapshot.forEach((doc) => {
          docMap[doc.id] = doc.data();
        });
        dateRange.forEach((date) => {
          const data = docMap[date] || {}; // Fetch data for the specific date or use an empty object if not found
          let obj = {
            date: date,
          };
          let rowNum = 0;
          let value = {
          };
          let idx = 0;
          for (const key of Object.keys(data).sort((a, b) => {
              return a.localeCompare(b);
            })) {
            const timestamp = data[key].timeCreated;
            const date = new Date(timestamp.seconds * 1000);
            value[data[key].bank] = {
              bank: data[key].bank,
              rates: [
                    ...(value[data[key].bank]?.rates || []),
                    {
                      B1Code: data[key].b1Code,
                      CurrencyCode: data[key].Currency,
                      Value: data[key].rate,
                      RateDate: data[key].rateDate,
                      CreateDate: this.formatDateFirebase(date),
                      Bank: data[key].bank,
                      isEvenRow: this.isEvenRow(idx++),
                    },
              ],
            };
            rowNum++;
          }
          obj.rowNum = rowNum;
          this.rateHistory.push({
            ...obj,
            value: Object.keys(value).map((k) => value[k]),
          });
        });
        this.isFirstRowExist = this.rateHistory[0].rowNum > 0;
        // console.log("this.rateHistory", this.rateHistory);
        // console.log("this.rateSimple", this.rateSimple);
        // console.log('this.exchangeRates',this.rateHistory) ;
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    },
    isEvenRow(idx) {
      return idx % 2 === 0 ? true : false;
    },
    getBankLogo(bank) {
      let src = "";
      switch (bank) {
        case "BCEL":
          src = "https://www.bcel.com.la/bcel/resources/imgs/logobcel.png";
          break;
        case "KBANK":
          src = "https://www.kasikornbank.com/SiteCollectionDocuments/about/img/logo/logo.png";
          break;
        case "SCB":
          src = "https://www.phutipat-vetiver.com/wp/wp-content/uploads/scb-icon.png";
          break;
        case "BBL":
          src = "https://www.bangkokbank.com/-/media/Feature/Identity/BBL%20Corporate/Favicon/BBL-Logo_152x152.png";
          break;
        case "KTB":
          src = "https://play-lh.googleusercontent.com/5t_2y4d6A66cJKQUwMRvr3X1krilGfVwjjz_OMKi8bTAaxgXMgkQWxhvAtqqtb_TRFc=w240-h480-rw";
          break;
        case "UOB":
          src = "https://www.fintechfutures.com/files/2019/03/UOB.jpg";
          break;
        case "BOT":
          src = "https://upload.wikimedia.org/wikipedia/commons/8/8c/Seal_of_the_Bank_of_Thailand.png";
          break;
        default:
          src = "";
          break;
      }
      return src;
    }
  },
  computed: mapState({
    selectedCompanyProductList: (state) =>
      state.companies.selectedCompanyProductList,
    isProductListLoading: (state) => state.companies.isProductListLoading,
    companyLogo: (state) => state.companies.selectedCompany.imageLogoUrl,
  }),
  watch: {
    dateSearch(val) {
      this.dateDsp = this.formatDate(val);
    },
    dateDsp(newVal) {
      this.fetchHistoryRate();
    },
  },
  mounted() {
    logActivity('page_view', { page_title: 'ExchangeRateHistory' })
    this.dateDsp = this.formatDate(this.dateSearch);
  },
};
</script>

<style lang="scss">
.width120 {
  width: 120px;
}
.custom-table {
  max-height: 800px;
  overflow-y: scroll !important;
  // position: relative;
  // position: fixed;
  // top: 0;
  // left: 0;
  // width: 100%;
  // z-index: 1000;
  // background-color: white; /* Ensure the header has a background */
}
.table-container {
  border-radius: 8px;
  overflow-y: auto;
  padding-bottom: 10px;
  height: 700px;
  // hide scrollbar
  &::-webkit-scrollbar {
    display: none;
  }
}

.exchange-rate-history-table {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  position: sticky;
  border-collapse: collapse;
  th, td {
    color:  rgba(0, 0, 0, 0.87);
    font-size: small;
    padding: 6px 8px;
  }
  td {
    border: 1px solid rgba(154, 156, 166, 0.5);
  }

  .even-row {
    background-color: #f5f5f5;
  }
  th {
    position: sticky;
    inset-block-start: 0;
    padding: 0;
  }
  th div {
    margin-left: .5px;
    padding: 6px 8px;
    background-color: #133265;
    color: #FFFFFF;
    outline: 1px solid rgb(255, 255, 255);
  }
  th:first-child div {
    border-top-left-radius: 8px;
  }
  th:last-child div {
    border-top-right-radius: 8px;
  }
}
.fixed-header .v-data-table-header th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white; /* Set background color for the header */
}
</style>
